import { getUserAttachmentPolicyChecker } from 'owa-attachment-policy';
import { lazyEvaluateSafeLink } from 'owa-safelinks-evaluator';
import getWacInfoForOneDriveJsApi from 'owa-attachment-wac/lib/services/getWacInfoForOneDriveJsApi';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export default async function isSharePointLinkPreviewable(url: string): Promise<boolean> {
    const policyChecker = getUserAttachmentPolicyChecker();
    const linkPreviewEnabledByPolicy = policyChecker.linkPreviewEnabled;

    if (!linkPreviewEnabledByPolicy) {
        // blocked by conditional access
        return false;
    }

    const evaluateSafeLink = await lazyEvaluateSafeLink.import();
    const safeLinkEvaluateResult = await evaluateSafeLink(url);
    const apiResponse = await getWacInfoForOneDriveJsApi(
        AttachmentDataProviderType.OneDrivePro,
        safeLinkEvaluateResult,
        true /* isEdit, jsAPI always in edit mode */,
        false /* redeemSharingLinkIfNecessary */,
        true /* returnEvenIfNoWacInfo */
    );

    if (apiResponse) {
        return true;
    }

    return false;
}
